import {
    getStatementDataState,
    StatementDataStateContext,
    StatementDataViewContext,
} from "@bToC/Store/Data/Statements/StatementSelector";
import { CustomState } from "@bToC/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { DoNotFollowLinks } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const location = getLocation(state);
    let statementNumber;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ statementNumber: string }>(location.search);
        statementNumber = parsedQuery.statementNumber;
    }

    const statementState = getStatementDataState(state, statementNumber);

    return {
        statementNumber,
        statementState,
        getStatementLinesParameter: state.customPagesReducer.statementDetails.getStatementLinesParameter,
        shouldLoadOrderStatusMappings: !getOrderStatusMappingDataView(state).value,
    };
};

const mapDispatchToProps = {};

export interface StatementDetailsPageStyles {
    loadFailedWrapper?: InjectableCss;
    loadFailedText?: TypographyPresentationProps;
}

export const statementDetailsPageStyles: StatementDetailsPageStyles = {
    loadFailedWrapper: {
        css: css`
            display: flex;
            height: 200px;
            justify-content: center;
            align-items: center;
            background-color: ${getColor("common.accent")};
        `,
    },
    loadFailedText: { weight: "bold" },
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;

class StatementDetailsPage extends React.Component<Props> {
    render() {
        const styles = statementDetailsPageStyles;
        return (
            <Page>
                {this.props.statementState.errorStatusCode === 404 ? (
                    <StyledWrapper {...styles.loadFailedWrapper}>
                        <Typography {...styles.loadFailedText}>{siteMessage("Statements_Not_Found")}</Typography>
                    </StyledWrapper>
                ) : (
                    <StatementDataStateContext.Provider value={this.props.statementState}>
                        <Zone contentId={this.props.id} zoneName="Content" />
                    </StatementDataStateContext.Provider>
                )}
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StatementDetailsPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
        fieldDefinitions: [DoNotFollowLinks],
    },
};

export default pageModule;

export const StatementDetailsPageContext = "StatementDetailsPage";
